import { Icon } from '@iconify/react';
import React, { useState, useEffect } from 'react';
import SectionHeading from './SectionHeading';
import Slider from 'react-slick';
import Modal from './Modal';
import { getCountryFlagIcon } from '../utils/countryFlag';

export default function Projects({ data }) {
  const [modal, setModal] = useState(false);
  const [modalType, setModalType] = useState('image');
  const [modalData, setModalData] = useState({});
  const { sectionHeading, allProjects } = data;
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768); // Adjust the breakpoint as needed
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handelProjectDetails = (item, itemType) => {
    if (itemType === 'image') {
      setModalData(item);
    } else {
      setModalData(item);
    }
    setModalType(itemType);

    setModal(!modal);
    console.log(modalType);
  };

  var settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 4000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    variableWidth: !isMobile, // Enable variableWidth only on large screens
  };

  return (
    <>
      <section className="project-section section gray-bg" id="project">
        <div className="container">
          <SectionHeading
            miniTitle={sectionHeading.miniTitle}
            title={sectionHeading.title}
          />
          <div
            className="full-width"
          >
            <Slider {...settings} className="slider-gap-24">
              {allProjects?.map((item, index) => {
                const isUpcoming = item.details?.status === 'Upcoming';
                const countryFlagIcon = getCountryFlagIcon(item.details?.country);
                return (
                <div key={index} style={{ width: '416px' }}>
                  <div className={`project-box${isUpcoming ? ' project-box--upcoming' : ''}`}>
                    <div className="project-media">
                      <img src={item.thumbUrl} alt="Thumb" />
                      {countryFlagIcon && (
                        <span className="project-country-flag" aria-hidden="true">
                          <Icon icon={countryFlagIcon} />
                        </span>
                      )}
                      {isUpcoming && (
                        <span className="project-upcoming-badge" aria-label="Upcoming project">
                          <Icon icon="bi:hourglass-split" />
                          <span>Upcoming</span>
                        </span>
                      )}
                      <span
                        className="gallery-link"
                        onClick={() => handelProjectDetails(item, 'image')}
                      >
                        <i>
                          <Icon icon="bi:plus" />
                        </i>
                      </span>
                    </div>
                    <div className="project-body">
                      <div className="text">
                        <h5>{item.title}</h5>
                        <span>{item.subTitle}</span>
                      </div>
                      <div className="link">
                        <span
                          className="p-link"
                          onClick={() => handelProjectDetails(item, 'details')}
                        >
                          <Icon icon={isUpcoming ? 'bi:hourglass-split' : 'bi:arrow-right'} />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )})}
            </Slider>
          </div>
        </div>
      </section>
      {modal && (
        <div className="mfp-wrap">
          <div className="mfp-container">
            <div className="mfp-bg" onClick={() => setModal(!modal)}></div>
            <div className="mfp-content">
              <button
                type="button"
                className="mfp-close"
                onClick={() => setModal(!modal)}
              >
                ×
              </button>
              {modalType === 'image' ? (
                <img src={modalData.thumbUrl} alt="Thumbnail" />
              ) : (
                <Modal modalData={modalData} />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
